import { createContext, useContext } from 'react';

const ToastContext = createContext(null);

const useToast = () => useContext(ToastContext);

export { ToastContext, useToast };